import {Client, ClientUser, Item, Workspace} from '../../../API';
import {mockClient, mockClientUser, mockWorkspace} from './fixtures';

const STORAGE_KEY = 'lgc-mock-db-v2';

export interface MockDb {
    client: Client;
    clientUsers: ClientUser[];
    workspaces: Workspace[];
    items: Item[];
}

function buildSeedDb(): MockDb {
    return {
        client: {...mockClient},
        clientUsers: [{...mockClientUser}],
        workspaces: [{...mockWorkspace}],
        items: [],
    };
}

function loadDb(): MockDb {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw) as MockDb;
            // Back-compat: seed with items array if missing from old persisted data.
            if (!parsed.items) {
                parsed.items = [];
            }
            return parsed;
        }
    } catch (error) {
        console.warn('[mock-backend] failed to read mock db from localStorage, reseeding', error);
    }
    return buildSeedDb();
}

let db: MockDb = loadDb();

export function getMockDb(): MockDb {
    return db;
}

function persist() {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
    } catch (error) {
        console.warn('[mock-backend] failed to persist mock db to localStorage', error);
    }
}

export function updateMockDb(mutate: (db: MockDb) => void): void {
    mutate(db);
    persist();
}

export function resetMockDb(): void {
    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.warn('[mock-backend] failed to clear mock db from localStorage', error);
    }
    db = buildSeedDb();
}

export function reloadMockDb(): void {
    db = loadDb();
}
